import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const WatermarkToolbarOverlayContext = createContext(null);

export const OVERLAY_COLOR = "color";
export const OVERLAY_POSITION = "position";

export function WatermarkToolbarOverlayProvider({ leftPanelSelector, children }) {
  const [overlay, setOverlay] = useState(null);

  const openOverlay = useCallback((next) => {
    setOverlay((current) => (current === next ? null : next));
  }, []);

  const closeOverlay = useCallback(() => setOverlay(null), []);

  const value = useMemo(
    () => ({
      leftPanelSelector,
      overlay,
      openOverlay,
      closeOverlay,
      isColorOpen: overlay === OVERLAY_COLOR,
      isPositionOpen: overlay === OVERLAY_POSITION,
    }),
    [closeOverlay, leftPanelSelector, openOverlay, overlay]
  );

  return (
    <WatermarkToolbarOverlayContext.Provider value={value}>
      {children}
    </WatermarkToolbarOverlayContext.Provider>
  );
}

export function useWatermarkToolbarOverlay() {
  return useContext(WatermarkToolbarOverlayContext);
}
